/**
 * Notification Service - يراقب الأعضاء الجدد ويرسل إشعارات
 */
import { toast } from '@/components/toast';
import { safeLocalStorage } from '@/utils/safeStorage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

class NotificationService {
  constructor() {
    this.isRunning = false;
    this.intervalId = null;
    this.lastCheck = null;
    this.lastMemberCount = 0;
    this.checkInterval = 10000; // 10 ثوانٍ
  }

  getAuthHeaders() {
    const token = safeLocalStorage.getItem('auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async checkNewMembers() {
    try {
      const headers = this.getAuthHeaders();
      if (!headers.Authorization) return;

      const params = new URLSearchParams();
      if (this.lastCheck) {
        params.append('since', this.lastCheck);
      }

      const response = await fetch(`${API}/notifications/new-members?${params}`, {
        headers
      });

      if (!response.ok) return;

      const data = await response.json();
      
      // إذا كان هناك أعضاء جدد
      if (data.new_members_count > 0 && data.total_members > this.lastMemberCount) {
        const newCount = data.total_members - this.lastMemberCount;
        
        if (newCount > 0 && this.lastMemberCount > 0) {
          // إرسال إشعار
          toast.members(data.total_members, newCount);
          
          // تشغيل صوت الإشعار (اختياري)
          this.playNotificationSound();
        }
      }

      this.lastMemberCount = data.total_members;
      this.lastCheck = data.timestamp;

    } catch (error) {
      console.error('Error checking new members:', error);
    }
  }

  playNotificationSound() {
    try {
      // يمكن إضافة صوت إشعار هنا
      // const audio = new Audio('/notification.mp3');
      // audio.play();
    } catch (e) {
      // تجاهل الأخطاء
    }
  }

  start() {
    if (this.isRunning) return;
    
    this.isRunning = true;
    
    // فحص أولي
    this.checkNewMembers();
    
    // فحص دوري
    this.intervalId = setInterval(() => {
      this.checkNewMembers();
    }, this.checkInterval);

    console.log('Notification service started');
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
    console.log('Notification service stopped');
  }

  // إعادة التشغيل
  restart() {
    this.stop();
    this.start();
  }
}

// إنشاء instance واحد
export const notificationService = new NotificationService();

export default notificationService;
